const desc = `<p><span class="bold">הפועל הצעיר</span> - 1934 05 25  [לא הצלחנו להשיג]</p>`;

export default desc;
